import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconFilters = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M8.256 1.899c-4.03.413-6.776 3.81-6.34 7.846.153 1.43.513 2.362 1.338 3.471.157.211 4.616 4.719 9.908 10.017l9.622 9.633v27.609l.137.367c.166.444.626.93 1.064 1.125.217.096.439.136.783.138.785.005 1.022-.141 2.358-1.451.622-.61 3.957-3.864 7.413-7.233 5.496-5.358 6.306-6.171 6.464-6.493l.181-.368.017-6.848.017-6.848 9.621-9.632c5.292-5.298 9.75-9.805 9.907-10.016.836-1.124 1.195-2.066 1.343-3.529.219-2.158-.523-4.304-1.997-5.779-.95-.95-2.038-1.534-3.549-1.907-.419-.103-1.96-.11-24.255-.118-13.094-.004-23.909.003-24.032.016m-.057 4.058c-.818.16-1.644.802-1.992 1.546-.439.937-.426 2.171.03 2.97.12.21 3.436 3.574 10.176 10.327 5.499 5.509 10.041 10.088 10.094 10.176.29.482.275-.084.309 12.47l.032 11.86 5.168-5.037 5.168-5.037v-6.607c0-4.084.024-6.735.063-6.941a3 3 0 0 1 .17-.569c.07-.155 3.529-3.663 10.137-10.283 6.275-6.286 10.092-10.156 10.195-10.336.332-.581.448-1.457.298-2.247a2.91 2.91 0 0 0-2.296-2.296c-.43-.081-47.137-.077-47.552.004" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconFilters.displayName = 'IconFilters';